import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { 
            Dialog, 
            DialogContent, 
            DialogContentText, 
            Typography,
            Grid,
            Button 
        } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
    textField: {
        width: '100%',
    },
    margin: {
        margin: theme.spacing(1),
        textAlign : "center"
    },
    buttonSubmit: {
        [theme.breakpoints.up('xs')]: {
            fontSize : '60%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#8DAB42'
        },
        [theme.breakpoints.up('sm')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#8DAB42'
        },
        [theme.breakpoints.up('md')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#8DAB42'
        },
        [theme.breakpoints.up('lg')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#8DAB42'
        },
        [theme.breakpoints.up('xl')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#8DAB42'
        },
    },
    
    buttonCancel: {
        [theme.breakpoints.up('xs')]: {
            fontSize : '60%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#434041'
        },
        [theme.breakpoints.up('sm')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#434041'
        },
        [theme.breakpoints.up('md')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#434041'
        },
        [theme.breakpoints.up('lg')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#434041'
        },
        [theme.breakpoints.up('xl')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#434041'
        },
    
    },
    dialogPaper: {
        [theme.breakpoints.up('xs')]: {
            height : '90%',
            width : "100%"
        },
        [theme.breakpoints.up('sm')]: {
            height : '70%',
            width : "40%"
        },
        [theme.breakpoints.up('md')]: {
            height : '70%',
            width : "40%"
        },
        [theme.breakpoints.up('lg')]: {
            height : '70%',
            width : "40%"
        },
        [theme.breakpoints.up('xl')]: {
            height : '70%',
            width : "40%"
        },
        
    },
    textLabel : {
        [theme.breakpoints.up('xs')]: {
            color : "#706D85",
            //fontFamily : "Roboto-Bold",
            fontSize : "100%"
        },
        [theme.breakpoints.up('sm')]: {
            color : "#706D85",
            //fontFamily : "Roboto-Bold",
            fontSize : "100%"
        },
        [theme.breakpoints.up('md')]: {
            color : "#706D85",
            //fontFamily : "Roboto-Bold",
            fontSize : "100%"
        },
        [theme.breakpoints.up('lg')]: {
            color : "#706D85",
            //fontFamily : "Roboto-Bold",
            fontSize : "100%"
        },
        [theme.breakpoints.up('xl')]: {
            color : "#706D85",
            //fontFamily : "Roboto-Bold",
            fontSize : "100%"
        },
        
    },
    textValue : {
        [theme.breakpoints.up('xs')]: {
            color : "#000000",
            //fontFamily : "Roboto-Regular",
            fontSize : "120%"
        },
        [theme.breakpoints.up('sm')]: {
            color : "#000000",
            //fontFamily : "Roboto-Regular",
            fontSize : "120%"
        },
        [theme.breakpoints.up('md')]: {
            color : "#000000",
            //fontFamily : "Roboto-Regular",
            fontSize : "120%"
        },
        [theme.breakpoints.up('lg')]: {
            color : "#000000",
            //fontFamily : "Roboto-Regular",
            fontSize : "120%"
        },
        [theme.breakpoints.up('xl')]: {
            color : "#000000",
            //fontFamily : "Roboto-Regular",
            fontSize : "120%"
        },
        
    },
    textTitle : {
        [theme.breakpoints.up('xs')]: {
            color : "#000000",
            //fontFamily : "Roboto-Regular",
            fontSize : "140%"
        },
        [theme.breakpoints.up('sm')]: {
            color : "#000000",
            //fontFamily : "Roboto-Regular",
            fontSize : "140%"
        },
        [theme.breakpoints.up('md')]: {
            color : "#000000",
            //fontFamily : "Roboto-Regular",
            fontSize : "140%"
        },
        [theme.breakpoints.up('lg')]: {
            color : "#000000",
            //fontFamily : "Roboto-Regular",
            fontSize : "140%"
        },
        [theme.breakpoints.up('xl')]: {
            color : "#000000",
            //fontFamily : "Roboto-Regular",
            fontSize : "140%"
        },
        
    },
    textButtons : {
        [theme.breakpoints.up('xs')]: {
            fontSize : '60%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('sm')]: {
            fontSize : '100%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('md')]: {
            fontSize : '100%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('lg')]: {
            fontSize : '100%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('xl')]: {
            fontSize : '100%',
            textAlign: 'justify',
        },
        
    },
    submit: {
        margin: (3, 0, 2),
        fontWeight: 'bold',
        fontSize: '0.6rem',
        //borderLeft: '3px solid #014587',
        color: '#1a1919',
        backgroundColor: "#ffffff",
        //fontFamily: 'Roboto-Medium',
        "&:hover": {
            backgroundColor: "#ffffff",
            //borderLeft: '3px solid #014587',
        }
    },
    buttonStandard: {
        fontSize: '1rem',
        color: '#ffffff',
        borderRadius: '4px',
        '&.Mui-disabled': {
            backgroundColor: "#a7a8a8",
        },
        '&:hover': {
            backgroundColor: "#706D85",
        },
        backgroundColor: "#2E2757",
        //fontFamily: 'MyriadPro-Bold',
    },
}));


const DialogConfirm = ({ open, title, description, onCloseDialog, onAceptDialog, titleButtonAccept, titleButtonCancel }) => {
    
    const classes = useStyles();

    return (
        <Dialog
            open={ open }
            onClose={ onCloseDialog }
            //fullWidth={true}
            maxWidth= 'sm'
            disableBackdropClick
            disableEscapeKeyDown
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            
        >

            <DialogContent>
                <DialogContentText id="alert-dialog-description" align="center">
                    <Typography component="p" variant="p" align = "center" className = {classes.textValue}>
                        { title }
                    </Typography>
                </DialogContentText>

                <Typography component="p" variant="p" align = "left" className = {classes.textValue}>
                    { description }
                </Typography>

                <br />

                <Grid container justifyContent='center'>
                    <Grid item xs={6} md={6} container justifyContent='center'>
                        <Button 
                            variant="contained"
                            className = {classes.buttonStandard}
                            style={{}}
                            onClick = { onAceptDialog}
                        >
                            { (titleButtonAccept) ? titleButtonAccept : "Aceptar" }
                        </Button>
                    </Grid>
                    <Grid item xs={6} md={6} container justifyContent='center'>
                        <Button
                            variant="contained"
                            className = {classes.buttonStandard}
                            style={{}} 
                            onClick = {onCloseDialog }>{ (titleButtonCancel) ? titleButtonCancel : "Cancelar" }</Button>
                    </Grid>
                </Grid>

            </DialogContent>
            
        </Dialog>
    );
};

export default DialogConfirm;